import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { fetchApi } from '../../../lib/fetchApi';
import { ClaimAlertState } from '../../claims/types';

export const getAlertClaim = async (claimId: number): Promise<ClaimAlertState> => {
    const response = await fetchApi.get(`/alert/claim/${claimId}`) as ClaimAlertState;
  	return response;
}

type QueryFnType = typeof getAlertClaim;

type UseClaimOptions = {
	claimId: number | null; 
	config?: QueryConfig<QueryFnType>;
};

export const useAlertClaim = ({ claimId, config = {} }: UseClaimOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['alertClaim', claimId],
        queryFn: () => getAlertClaim(claimId!), // el "!" es seguro porque solo se ejecuta si enabled es true
        enabled: !!claimId,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};